export default __webpack_public_path__ + "static/background3-0e21df3bda774abaed3e7ffa6284d4d1.png";